module.exports = __webpack_public_path__ + "static/contact-52b3e74232d2d4a7e9823ff5f845f258.jpg";